$(document).ready(function (){
    $("#import_transfer").on('click', function (e){
        e.preventDefault()
        $("#modal-import-transfer").modal('show')
    })



    $("#form-import-transfer").on('submit', function (e){
        e.preventDefault()
        const formData = new FormData($('#form-import-transfer')[0]);
        let route = "transfer-import";
        $.ajax({
            url: route,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {
                $('#btn-import-transfer').prop('disabled', true).text('Importando...');
            },
            success: function (response) {
                alertWithBtn(response.mensaje)
                location.reload()
                $('#modal-import-transfer').modal('hide');

            },
            error: function (xhr) {
                const errores = xhr.responseJSON?.errors;
                if (errores) {
                    alert(Object.values(errores).flat().join('\n'));
                } else {
                    alert('Ocurrió un error al importar.');
                }
            },
            complete: function () {
                $('#btn-import-transfer').prop('disabled', false).html('<i class="fas fa-file-import mr-1"></i> Importar');
            }
        });
    })

    $('#btn-import-transfer-sx').on('click', function () {

    });

    $(".form-add-article").on('submit', function (e){
        e.preventDefault()
        let data = new FormData(this)

        $.ajax({
            url: "/add-item",
            method: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {

            },
            success: function (response) {

                if (response.success ) {
                    document.getElementById('div-table-detail-transfer').innerHTML = response.view;

                    alertWithBtn(response.msg)
                    return
                }
                alertError(response.msg)

            },
            error: function (xhr) {
                const errores = xhr.responseJSON?.errors;
                if (errores) {
                    alert(Object.values(errores).flat().join('\n'));
                } else {
                    alert('Ocurrió un error al importar.');
                }
            },
            complete: function () {
                $('#btn-import-transfer').prop('disabled', false).html('<i class="fas fa-file-import mr-1"></i> Importar');
            }
        });
    })




    $(".form-print-transfer").on('submit', function (e){

        /*
        e.preventDefault();
        let uuid = $(this).find('input[name="uuid"]').val();
        window.open('/print-transfer?uuid=' + uuid, '_blank');
         */
        e.preventDefault();
        let uuid = $(this).find('input[name="uuid"]').val();

        // Crear o limpiar iframe
        let iframe = document.getElementById('printFrame');
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.id = 'printFrame';
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        }

        // Cargar la vista en el iframe
        iframe.src = '/print-transfer?uuid=' + uuid;

        // Cuando cargue, imprimir
        iframe.onload = function() {
            iframe.contentWindow.print();
        };
    })
})
